<template>
  <div class="t-file">
    <div class="t-file__svg">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.83335 17.5H14.1667C14.6087 17.5 15.0326 17.3244 15.3452 17.0118C15.6578 16.6993 15.8334 16.2754 15.8334 15.8333V7.845C15.8333 7.624 15.7455 7.41208 15.5892 7.25583L11.0775 2.74417C10.9213 2.58788 10.7094 2.50005 10.4884 2.5H5.83335C5.39133 2.5 4.9674 2.67559 4.65484 2.98816C4.34228 3.30072 4.16669 3.72464 4.16669 4.16667V15.8333C4.16669 16.2754 4.34228 16.6993 4.65484 17.0118C4.9674 17.3244 5.39133 17.5 5.83335 17.5Z"
          stroke="#C0C0CC"
          stroke-width="1.4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="t-file__content">
      <div class="t-file__name">{{ file.name }}</div>
      <div class="t-file__row">
        <div class="t-file__type">{{ file.type }}</div>
        <div class="t-file__size">{{ file.size + $root.staticText.lk.requestsMb }}</div>
      </div>
    </div>
    <div class="t-file__right">
      <div v-if="isDelete" @click="$emit('delete-file')" class="t-file__delete">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 5L15 15M5 15L15 5L5 15Z" stroke="#C0C0CC" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <a v-if="isDownload" :href="file.link" target="_blank" class="t-file__download">
        {{ $root.staticText.lk.requestsDownload }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lk-file',
  props: {
    file: Object,
    isDelete: {
      type: Boolean,
      default: false,
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/lk/lk-file/lk-file.vue